const ConfigurationPlaceholder = () => (
  <div
    className="flex min-h-[610px] flex-col items-center justify-center gap-1 rounded-md border border-navy-100 text-center"
    data-testid="configuration-placeholder"
  >
    <p className="text-xl font-semibold leading-7 text-gray-700">
      Configuration
    </p>
    <p className="text-lg font-semibold leading-7 text-gray-500">
      Configuration settings are coming in Phase 2 once the backend schema is
      finalised.
    </p>
  </div>
);

export default ConfigurationPlaceholder;
